import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="sessionstorage" id="sessionstorage"></a>
    <h1 {...{
      "id": "windowsessionstorage"
    }}>{`window.sessionStorage`}</h1>
    <p>{`SessionStorage is available as `}<inlineCode parentName="p">{`window.sessionStorage`}</inlineCode>{`
Provides a local key/value store useful for storing data that persists only for the plugin's current session.
For more information about the API itself, see the `}<a parentName="p" {...{
        "href": "../LocalStorage/"
      }}>{`localStorage`}</a>{` API.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      